export { default } from './TabsViewNew';
